import { Component } from '@angular/core';
import { BlockAudio } from '@src/app/@shared/models/step.model';
import { BlockAbstractComponent } from '@app/components/blocks/block.abstract.component';

@Component({
  selector: 'pl-block-audio',
  templateUrl: './block-audio.component.html',
})
export class BlockAudioComponent extends BlockAbstractComponent<BlockAudio, null> {
  protected override initForm(): void {}

  protected override patchFormWithEmptyValue(): void {}

  protected override patchFormFromBlock(): void {}
}
